import { useEffect, useState } from "react";
import moment from "moment";
import { GridColDef } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import { getStatusColor } from "../../../utils/functionHelper";
import { getLocation } from "../../../services/Location";
import { getStatus } from "../../../services/Appointment";
import { baseURL } from "../../../config/api";
import { CustomDataGrid } from "../../../components/CustomDataGrid";
import { CustomDateField } from "../../../components/CustomDateField";
import { Tabs } from "../../../components/Tabs";
import { getCustomerServices } from "../../../services/Services";
import { Menu, MenuItem, Stack } from "@mui/material";
import { formatUSPhone } from "../../../utils/phoneFormatter";

const tabs = [
    {
        label: "All",
    },
    {
        label: "Scheduled",
    },
    {
        label: "Queued",
    },
    {
        label: "InProgress",
    },
    {
        label: "Done",
    },
    {
        label: "NoShow",
    },
    {
        label: "Cancelled",
    }
]

const filterItems = [
    {
        id: 0,
        label: "Service No",
    },
    {
        id: 1,
        label: "Customer Name",
    }
]

export const Appointments = () => {
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const [searchTableData, setSearchTableData] = useState<any[]>([]);
    const [searchValue, setSearchValue] = useState<string>("");
    const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
    const [selectedFilter, setSelectedFilter] = useState<string>(filterItems[0].label);
    const [filterValue, setFilterValue] = useState(0);
    const [totalLength, setTotalLength] = useState<number>(0);
    const [loading, setLoading] = useState(true);
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [activeTabLabel, setActiveTabLable] = useState<string>("All");
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const [date, setDate] = useState<string>(moment().format("YYYY-MM-DD"));
    const [locationId, setLocationId] = useState<number>(0);
    const [locationOptions, setLocationOptions] = useState<any[]>([]);
    const [serviceId, setServiceId] = useState<number>(0);
    const [serviceOptions, setServiceOptions] = useState<any[]>([]);
    const [status, setStatus] = useState<any[]>([]);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const columns: GridColDef[] = [
        {
            field: "serviceNumber",
            headerName: "Service No.",
            flex: 1,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                return (
                    <Link to={`/admin/services/editservice?id=${params?.row?.appointmentID}`} className="underline text-[#0000ff]">
                        {params?.value}
                    </Link>
                );
            },
        },
        {
            field: "timeSlot",
            headerName: "Time",
            editable: false,
            sortable: false,
            flex: 1,
        },
        {
            field: "serviceName",
            headerName: "Service Name",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "firstName",
            headerName: "First Name",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "lastName",
            headerName: "Last Name",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "phone",
            headerName: "Phone",
            type: "number",
            flex: 1,
            editable: false,
            sortable: false,
            renderCell: (params) =>
                params.value ? formatUSPhone(params.value) : ""
        },
        {
            field: "email",
            headerName: "Email",
            type: "number",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "status",
            headerName: "Status",
            flex: 1,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                const color = getStatusColor(params.value);
                return (
                    <div className="flex items-end h-full">
                        <span className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold ${color.colorBg} ${color.colorText}`}>
                            {params.value}
                        </span>
                    </div>
                );
            }
        },

    ];

    useEffect(() => {
        getLocation()
            .then((data) => {
                setLocationOptions(() => data?.map((loc: any) => {
                    return {
                        value: loc?.id,
                        label: loc?.locationName
                    }
                }))
            })
            .catch((error) => {
                console.error(error)
            })
    }, [])


    useEffect(() => {
        getStatus("Appointment")
            .then((data) => {
                setStatus(() => data?.map((status: any) => {
                    return {
                        id: status.statusID,
                        statusValue: status.statusValue
                    }
                }))
            })
            .catch((error) => {
                console.error(error)
            })
    }, [])

    useEffect(() => {
        getCustomerServices()
            .then((data) => {
                setServiceOptions(() => data?.map((service: any) => {
                    return {
                        value: service?.serviceID,
                        label: service?.serviceName
                    }
                }))
            }).catch((error) => {
                setServiceOptions([]);
                console.error(error);
            })
    }, [])

    useEffect(() => {
        let timeOutId: NodeJS.Timeout;

        if (searchValue !== "") {
            timeOutId = setTimeout(() => {
                const newPaginationModel = {
                    page: 0,
                    pageSize: paginationModel?.pageSize,
                };

                setPaginationModel(newPaginationModel);
            }, 1000);
        }

        return () => clearTimeout(timeOutId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);


    useEffect(() => {
        if (searchValue !== "") {
            filterApiCall(paginationModel);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel, locationId, date, activeIndex, serviceId])

    const filterApiCall = (newPaginationModel: any) => {
        switch (filterValue) {
            case 0:
                if (locationId > 0 && serviceId === 0) {
                    if (date && activeIndex === 0) {
                        setLoading(true);
                        const updatedDate = moment(date).endOf('day');
                        let formatDateString = updatedDate.format('YYYY-MM-DD');
                        getAppointmentData(`appointments/GetApointmentsReportPagingByLocationIdAndAppoinmentDateAndSearchByServiceNumber?serviceNumber=${searchValue}&locationId=${locationId}&appointmentDate=${formatDateString}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
                    }
                    else if (date && activeIndex > 0) {
                        setLoading(true);
                        const updatedDate = moment(date).endOf('day');
                        let formatDateString = updatedDate.format('YYYY-MM-DD');
                        const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                        getAppointmentData(`appointments/GetApointmentsReportPagingByLocationIdAndAppoinmentDateAndStatusAndSearchByServiceNumber?serviceNumber=${searchValue}&locationId=${locationId}&appointmentDate=${formatDateString}&statusId=${statusId}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
                    }

                }
                else if (locationId > 0 && serviceId > 0) {
                    if (date && activeIndex === 0) {
                        setLoading(true);
                        const updatedDate = moment(date).endOf('day');
                        let formatDateString = updatedDate.format('YYYY-MM-DD');
                        getAppointmentData(`appointments/GetApointmentsReportPagingByLocationIdAndAppoinmentDateAndServiceTypeAndSearchByServiceNumber?serviceNumber=${searchValue}&locationId=${locationId}&appointmentDate=${formatDateString}&seviceTypeId=${serviceId}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
                    }
                    else if (date && activeIndex > 0) {
                        setLoading(true);
                        const updatedDate = moment(date).endOf('day');
                        let formatDateString = updatedDate.format('YYYY-MM-DD');
                        const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                        getAppointmentData(`appointments/GetApointmentsReportPagingByLocationIdAndAppoinmentDateAndStatusAndServiceTypeAndSearchByServiceNumber?serviceNumber=${searchValue}&locationId=${locationId}&appointmentDate=${formatDateString}&statusId=${statusId}&seviceTypeId=${serviceId}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
                    }

                }
                else if (locationId === 0 && serviceId > 0) {
                    if (date && activeIndex === 0) {
                        setLoading(true);
                        const updatedDate = moment(date).endOf('day');
                        let formatDateString = updatedDate.format('YYYY-MM-DD');
                        getAppointmentData(`appointments/GetApointmentsReportPagingByAppoinmentDateAndServcieIdAndSearchByServiceNumber?serviceNumber=${searchValue}&appointmentDate=${formatDateString}&serviceTypeId=${serviceId}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
                    }
                    else if (date && activeIndex > 0) {
                        setLoading(true);
                        const updatedDate = moment(date).endOf('day');
                        let formatDateString = updatedDate.format('YYYY-MM-DD');
                        const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                        getAppointmentData(`appointments/GetApointmentsReportPagingByAppoinmentDateAndServcieIdAndStatusAndSearchByServiceNumber?serviceNumber=${searchValue}&appointmentDate=${formatDateString}&statusId=${statusId}&seviceTypeId=${serviceId}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
                    }
                }
                else {
                    if (date && activeIndex === 0) {
                        setLoading(true);
                        const updatedDate = moment(date).endOf('day');
                        let formatDateString = updatedDate.format('YYYY-MM-DD');
                        getAppointmentData(`appointments/GetAppointmentsReportPagingByAppointmentDateAndSearchByServiceNumber?serviceNumber=${searchValue}&appointmentDate=${formatDateString}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
                    }
                    else if (date && activeIndex > 0) {
                        setLoading(true);
                        const updatedDate = moment(date).endOf('day');
                        let formatDateString = updatedDate.format('YYYY-MM-DD');
                        const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                        getAppointmentData(`appointments/GetApointmentsReportPagingByAppoinmentDateAndStatusAndSearchByServiceNumber?serviceNumber=${searchValue}&appointmentDate=${formatDateString}&statusId=${statusId}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
                    }


                }
                break;
            case 1:
                if (locationId > 0 && serviceId === 0) {
                    if (date && activeIndex === 0) {
                        setLoading(true);
                        const updatedDate = moment(date).endOf('day');
                        let formatDateString = updatedDate.format('YYYY-MM-DD');
                        getAppointmentData(`appointments/GetApointmentsReportPagingByLocationIdAndAppoinmentDateAndSearchByCustomerName?customerName=${searchValue}&locationId=${locationId}&appointmentDate=${formatDateString}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
                    }
                    else if (date && activeIndex > 0) {
                        setLoading(true);
                        const updatedDate = moment(date).endOf('day');
                        let formatDateString = updatedDate.format('YYYY-MM-DD');
                        const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                        getAppointmentData(`appointments/GetApointmentsReportPagingByLocationIdAndAppoinmentDateAndStatusAndSearchByCustomerName?customerName=${searchValue}&locationId=${locationId}&appointmentDate=${formatDateString}&statusId=${statusId}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
                    }

                }
                else if (locationId > 0 && serviceId > 0) {
                    if (date && activeIndex === 0) {
                        setLoading(true);
                        const updatedDate = moment(date).endOf('day');
                        let formatDateString = updatedDate.format('YYYY-MM-DD');
                        getAppointmentData(`appointments/GetApointmentsReportPagingByLocationIdAndAppoinmentDateAndServiceTypeAndSearchByCustomerName?customerName=${searchValue}&locationId=${locationId}&appointmentDate=${formatDateString}&seviceTypeId=${serviceId}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
                    }
                    else if (date && activeIndex > 0) {
                        setLoading(true);
                        const updatedDate = moment(date).endOf('day');
                        let formatDateString = updatedDate.format('YYYY-MM-DD');
                        const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                        getAppointmentData(`appointments/GetApointmentsReportPagingByLocationIdAndAppoinmentDateAndStatusAndServiceTypeAndSearchByCustomerName?customerName=${searchValue}&locationId=${locationId}&appointmentDate=${formatDateString}&statusId=${statusId}&seviceTypeId=${serviceId}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
                    }

                }
                else if (locationId === 0 && serviceId > 0) {
                    if (date && activeIndex === 0) {
                        setLoading(true);
                        const updatedDate = moment(date).endOf('day');
                        let formatDateString = updatedDate.format('YYYY-MM-DD');
                        getAppointmentData(`appointments/GetApointmentsReportPagingByAppoinmentDateAndServcieIdAndSearchByCustomerName?customerName=${searchValue}&appointmentDate=${formatDateString}&serviceTypeId=${serviceId}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
                    }
                    else if (date && activeIndex > 0) {
                        setLoading(true);
                        const updatedDate = moment(date).endOf('day');
                        let formatDateString = updatedDate.format('YYYY-MM-DD');
                        const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                        getAppointmentData(`appointments/GetApointmentsReportPagingByAppoinmentDateAndServcieIdAndStatusAndSearchByCustomerName?customerName=${searchValue}&appointmentDate=${formatDateString}&statusId=${statusId}&seviceTypeId=${serviceId}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
                    }
                }
                else {
                    if (date && activeIndex === 0) {
                        setLoading(true);
                        const updatedDate = moment(date).endOf('day');
                        let formatDateString = updatedDate.format('YYYY-MM-DD');
                        getAppointmentData(`appointments/GetAppointmentsReportPagingByAppointmentDateAndSearchByCustomerName?customerName=${searchValue}&appointmentDate=${formatDateString}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
                    }
                    else if (date && activeIndex > 0) {
                        setLoading(true);
                        const updatedDate = moment(date).endOf('day');
                        let formatDateString = updatedDate.format('YYYY-MM-DD');
                        const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                        getAppointmentData(`appointments/GetApointmentsReportPagingByAppoinmentDateAndStatusAndSearchByCustomerName?customerName=${searchValue}&appointmentDate=${formatDateString}&statusId=${statusId}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
                    }


                }
                break;
        }

    }

    useEffect(() => {
        if (searchValue === "" && !isFirstTime) {
            const newPaginationModel = {
                page: 0,
                pageSize: paginationModel?.pageSize,
            };

            setPaginationModel(newPaginationModel);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (searchValue === "") {
            setIsFirstTime(false)
            emptySearchApiCall(paginationModel);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel, locationId, date, activeIndex, serviceId])

    const emptySearchApiCall = (newPaginationModel: any) => {
        if (locationId > 0 && serviceId === 0) {
            if (date && activeIndex === 0) {
                setLoading(true);
                const updatedDate = moment(date).endOf('day');
                let formatDateString = updatedDate.format('YYYY-MM-DD');
                getAppointmentData(`appointments/GetApointmentsReportPagingByLocationIdAndAppoinmentDate?locationId=${locationId}&appointmentDate=${formatDateString}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
            }
            else if (date && activeIndex > 0) {
                setLoading(true);
                const updatedDate = moment(date).endOf('day');
                let formatDateString = updatedDate.format('YYYY-MM-DD');
                const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                getAppointmentData(`appointments/GetApointmentsReportPagingByLocationIdAndAppoinmentDateAndStatus?locationId=${locationId}&appointmentDate=${formatDateString}&statusId=${statusId}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
            }

        }
        else if (locationId > 0 && serviceId > 0) {
            if (date && activeIndex === 0) {
                setLoading(true);
                const updatedDate = moment(date).endOf('day');
                let formatDateString = updatedDate.format('YYYY-MM-DD');
                getAppointmentData(`appointments/GetApointmentsReportPagingByLocationIdAndAppoinmentDateAndServiceType?locationId=${locationId}&appointmentDate=${formatDateString}&seviceTypeId=${serviceId}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
            }
            else if (date && activeIndex > 0) {
                setLoading(true);
                const updatedDate = moment(date).endOf('day');
                let formatDateString = updatedDate.format('YYYY-MM-DD');
                const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                getAppointmentData(`appointments/GetApointmentsReportPagingByLocationIdAndAppoinmentDateAndStatusAndServiceType?locationId=${locationId}&appointmentDate=${formatDateString}&statusId=${statusId}&seviceTypeId=${serviceId}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
            }

        }
        else if (locationId === 0 && serviceId > 0) {
            if (date && activeIndex === 0) {
                setLoading(true);
                const updatedDate = moment(date).endOf('day');
                let formatDateString = updatedDate.format('YYYY-MM-DD');
                getAppointmentData(`appointments/GetApointmentsReportPagingByAppoinmentDateAndServcieId?appointmentDate=${formatDateString}&serviceTypeId=${serviceId}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
            }
            else if (date && activeIndex > 0) {
                setLoading(true);
                const updatedDate = moment(date).endOf('day');
                let formatDateString = updatedDate.format('YYYY-MM-DD');
                const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                getAppointmentData(`appointments/GetApointmentsReportPagingByAppoinmentDateAndServcieIdAndStatus?appointmentDate=${formatDateString}&statusId=${statusId}&seviceTypeId=${serviceId}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
            }
        }
        else {
            if (date && activeIndex === 0) {
                setLoading(true);
                const updatedDate = moment(date).endOf('day');
                let formatDateString = updatedDate.format('YYYY-MM-DD');
                getAppointmentData(`appointments/GetAppointmentsReportPagingByAppointmentDate/${formatDateString},${newPaginationModel?.page},${newPaginationModel?.pageSize}`);
            }
            else if (date && activeIndex > 0) {
                setLoading(true);
                const updatedDate = moment(date).endOf('day');
                let formatDateString = updatedDate.format('YYYY-MM-DD');
                const statusId = status?.filter((item: any) => item?.statusValue === activeTabLabel)[0]?.id;
                getAppointmentData(`appointments/GetApointmentsReportPagingByAppoinmentDateAndStatus?appointmentDate=${formatDateString}&statusId=${statusId}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`);
            }


        }

    }

    const getAppointmentData = (apiUrl: string) => {
        fetch(`${baseURL}${apiUrl}`)
            .then((res) => res.json())
            .then((data) => {
                const result = data?.appointments?.map((item: any) => {
                    return {
                        ...item,
                        id: item?.appointmentID,
                        timeSlot: moment(item?.timeSlot, "HH:mm").format("hh:mm A"),
                        appointmentDate: moment(new Date(item?.appointmentDate)).format("MM/DD/YYYY"),
                        firstName: item?.customer ? item?.customer?.firstName : "",
                        lastName: item?.customer ? item?.customer?.lastName : "",
                        phone: item?.customer ? item?.customer?.phone : "",
                        email: item?.customer ? item?.customer?.email : "",
                    };
                })

                setSearchTableData(result);
                setTotalLength(data?.count);
                setLoading(false);
            })
            .catch(error => {
                setSearchTableData([]);
                setTotalLength(0);
                setLoading(false);
                console.error(error);
            });


    }

    const hanbleTabChange = (index: number, tab: any) => {
        setActiveIndex(tab?.id || index);
        setActiveTabLable(tab?.label);
        setCurrentIndex(index);
        setPaginationModel({
            page: 0,
            pageSize: 10,
        })
    }

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };


    return (
        <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
            <div className="w-full h-full bg-white p-4 rounded-md">
                <div className="flex items-center justify-between py-2">
                    <div className="w-full">
                        <Tabs tabs={tabs} onChange={(index, tab) => hanbleTabChange(index, tab)} activeIndex={currentIndex} />
                    </div>
                    <div className="flex items-center gap-1.5">
                        <div>
                            <select
                                value={serviceId}
                                onChange={(e) => setServiceId(Number(e.target.value))}
                                className="w-[140px] border border-gray-300 rounded-md p-3 text-sm outline-none focus:border-primary bg-white"
                            >
                                <option value={0}>
                                    All
                                </option>
                                {serviceOptions.map((service: any, index: number) => (
                                    <option key={index} value={service?.value}>
                                        {service?.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <select
                                value={locationId}
                                onChange={(e) => setLocationId(Number(e.target.value))}
                                className="w-[170px] border border-gray-300 rounded-md p-3 text-sm outline-none focus:border-primary bg-white"
                            >
                                <option value={0}>
                                    All
                                </option>
                                {locationOptions.map((loc: any, index: number) => (
                                    <option key={index} value={loc?.value}>
                                        {loc?.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="flex items-center gap-1.5">
                            <button className={`px-[4px] py-[6px] rounded-lg border flex items-center justify-center`}>
                                <span className="material-symbols-outlined text-[25px] font-light"
                                    onClick={() =>
                                        setDate(() => {
                                            const d = new Date(date);
                                            d.setDate(d.getDate() - 1);
                                            return d.toISOString().split("T")[0];
                                        })
                                    }>
                                    chevron_left
                                </span>
                            </button>


                            <CustomDateField
                                value={date}
                                onChange={(value) => { setDate(value) }}
                                className="w-[110px] border border-gray-300 rounded-xl px-[5px] py-[10px] text-sm outline-none focus:border-primary"
                                required={true}
                                showValidMessage={false}
                                isModified={true}
                            />

                            <button className={`px-[4px] py-[6px] rounded-lg border flex items-center justify-center`}>
                                <span className="material-symbols-outlined text-[25px] font-light"
                                    onClick={() =>
                                        setDate(() => {
                                            const d = new Date(date);
                                            d.setDate(d.getDate() + 1);
                                            return d.toISOString().split("T")[0];
                                        })
                                    }
                                >
                                    chevron_right
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className={`w-full border border-[#E4E7EC] rounded-[16px]`}>
                    <div className={`flex justify-between items-center p-4 border-b border-[#E4E7EC]`}>
                        <div className="flex items-center gap-1.5">

                            <h2 className={`text-lg font-semibold text-[#1D2939]`}>Appointments</h2>
                        </div>
                        <div className="flex items-center gap-1.5">
                            <div >
                                <button
                                    className={`flex items-center justify-between py-[5px] px-[12px] gap-2.5 rounded-lg border border-solid`}
                                    aria-controls={open ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    onClick={handleClick}
                                >
                                    <Stack
                                        direction="row"
                                        spacing={1}
                                        alignItems={"center"}
                                        justifyContent={"center"}
                                    >
                                        <span className={` text-[14px] font-medium text-black-rgba`}>{selectedFilter}</span>
                                        {open ? <span className={`material-symbols-outlined  text-[25px] font-extralight`}>
                                            keyboard_arrow_up
                                        </span> : <span className={`material-symbols-outlined  text-[25px] font-extralight`}>
                                            keyboard_arrow_down
                                        </span>}
                                    </Stack>
                                </button>

                                <Menu
                                    id="basic-menu"
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                    slotProps={{
                                        paper: {
                                            sx: {
                                                width: 170,
                                            }
                                        }
                                    }}
                                >
                                    {
                                        filterItems?.map((filter, index) => (
                                            <>
                                                <MenuItem
                                                    key={index}
                                                    sx={{ fontSize: "12px", marginBlock: "0px" }}
                                                    onClick={() => {
                                                        setSelectedFilter(filter.label)
                                                        setFilterValue(filter.id)
                                                        setAnchorEl(null);

                                                    }}>
                                                    <span className={`text-[16px] font-medium text-black-rgba`}>{filter.label}</span>
                                                </MenuItem>

                                            </>

                                        ))
                                    }
                                </Menu>
                            </div>
                            <div className={`flex px-[5px] py-[6px] items-center gap-2.5 rounded-lg border shadow-sm`}>
                                <span className={`material-symbols-outlined text-[25px] font-light text-black-rgba`}>
                                    search
                                </span>
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    className={`border-none outline-none w-full bg-transparent`}
                                    onChange={(e) => setSearchValue(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    <CustomDataGrid
                        filteredRows={searchTableData}
                        columns={columns?.map(col => ({
                            ...col,
                            headerClassName: "bg-[#F9FAFB]",
                        }))}
                        loading={loading}
                        totalLength={totalLength}
                        paginationModel={paginationModel}
                        setPaginationModel={setPaginationModel}
                    />
                </div>
            </div>

        </div>
    )
}